import { useQuery } from "@tanstack/react-query"
import API from "api"
import { queries } from "api/queries"
import { DeliveryMode } from "api/resources/learningItems/types"
import { context } from "global/Context/context"
import { useContext } from "react"
import {
  cpatType,
  GSG_CPAT_SLUG_PATTERN,
  learningItemSlugs,
} from "utils/constants"

export const useEnrollments = () => {
  const { enrollments } = useContext(context)

  const pgctl = enrollments?.data?.find(
    enrollment => enrollment.slug === learningItemSlugs.pgctl
  )

  const hasMed = enrollments?.data?.find(
    enrollment => enrollment.slug === learningItemSlugs.med
  )
  const hasImpactCourse = enrollments?.data?.find(
    enrollment => enrollment.slug === learningItemSlugs.impactCourse
  )

  const pgctlDeliveryMode = pgctl?.deliveryMode

  const isNewDeliveryMode = pgctlDeliveryMode
    ? [
        DeliveryMode.STARTER,
        DeliveryMode.PROFESSIONAL,
        DeliveryMode.EXECUTIVE,
        DeliveryMode.TDC,
      ].includes(pgctlDeliveryMode)
    : false

  const showTermBreakdownInPGCTL = isNewDeliveryMode

  const allCpats = enrollments?.data?.filter(
    enrollment => enrollment.type === cpatType
  )

  const latestCPAT = allCpats?.[0]

  const hasCpat = Boolean(latestCPAT)

  const hasCompletedCpat = Boolean(latestCPAT && latestCPAT.progress === 100)

  const hasLearningPrograms = Boolean(
    enrollments?.data?.some(
      enrollment =>
        enrollment.type === "course" ||
        enrollment.type === "certification" ||
        enrollment.type === "qualification"
    )
  )

  const throughGSG = !!latestCPAT?.slug.includes(GSG_CPAT_SLUG_PATTERN)

  const isTDC = pgctl?.deliveryMode === DeliveryMode.TDC

  const batch = useQuery({
    refetchOnMount: false,
    queryFn: () => API.batch.listBatches(),
    queryKey: queries.batch.listBatches().queryKey,
    enabled: isTDC,
  })

  return {
    hasLearningPrograms,
    enrollments: enrollments.data,
    ...enrollments,
    batch: batch.data?.[0],
    pgctl: {
      isPGCTLUser: pgctl,
      deliveryMode: pgctlDeliveryMode,
      showTermBreakdown: showTermBreakdownInPGCTL,
      isNewDeliveryMode,
    },
    cpat: {
      latestCPAT,
      hasCpat,
      hasCompletedCpat,
      throughGSG,
    },
    hasMed,
    hasImpactCourse,
  }
}
